import { User } from '@beatgig/api'
import { useGet } from '@beatgig/api-hooks'
import { GetUser, OpenAPI } from '@beatgig/api-services'
import useAuth from './use-auth'
import { ConfigInterface } from 'swr'

const useMyAccount = (config?: ConfigInterface<GetUser | null>) => {
  // let me: UserAccount | null = null

  const auth = useAuth()

  const uid = auth?.user?.uid

  const {
    error,
    data,
    isValidating,
    mutate,
    revalidate,
  } = useGet<GetUser | null>(
    () => (uid ? User.swrKey(uid) : null),
    async (uid) => {
      const firebase = await import('firebase/app')
      console.log('[will-get-user]', {
        token: await firebase.auth().currentUser?.getIdToken(false),
        uid,
        openAPIToken:
          typeof OpenAPI.TOKEN === 'function'
            ? await OpenAPI.TOKEN?.()
            : OpenAPI.TOKEN,
      })

      return User.me()
    },
    config
  )

  // if (swr.error) {
  //   const { error } = swr
  //   console.error('[use-my-account]', error?.body?.message ?? error?.message)
  // }

  /**
   * This is always true, but we just use it temporarily so that the TS compiler doesn't automatically cast our user type.
   *
   * That way, we can make if statements for user type elsewhere.
   *
   * This is only meant for the admins temporarily.
   */
  // if (Math.random() > -1 && user?.displayName) {
  //   me = ({
  //     user_role: UserRole.ADMIN,
  //     // admin_permissions: [AdminPermissions.EditArtist],
  //     displayName: user?.displayName || 'Admin',
  //     name: user.displayName,
  //     // email: '',
  //     // phone_number: '',
  //     // user_type: '' as BuyerUserType.BAR,
  //   } as any) as UserAccount
  // }

  return {
    error,
    data,
    isValidating,
    mutate,
    revalidate,
    isLoading: !data && !error && isValidating,
  }
}

export default useMyAccount
